<div class="logo">
	<img ngSrc="assets/full-logo.svg" alt="AllaiHealth Logo" height="68" width="129" priority />
</div>

<div class="content">
	<router-outlet></router-outlet>
</div>
